import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IOfficer } from "../interface/user/officer/IOfficer";

enum OfficerServiceEnum {
  getAll = "/all",
  save = "",
  getById = "/"
}

export default class OfficerService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/officer");
  }

  public getAll = async (): Promise<IOfficer[]> => await this.GET(OfficerServiceEnum.getAll);
  public getById = async (id): Promise<IOfficer> => await this.GET(OfficerServiceEnum.getById + id);
  public save = async (data): Promise<IOfficer> => await this.POST(OfficerServiceEnum.save, data);
}
